import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import hamMenu from '../assets/svg/ham-menu.svg';
import hamMenuClose from '../assets/svg/ham-menu-close.svg';
import profileLogo from '../assets/png/profile.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Constante para la duración del scroll
  const SCROLL_DURATION = 300;

  // Efecto para desplazarse al inicio al cambiar de ruta
  useEffect(() => {
    window.scrollTo(0, 0); // Desplaza la vista al inicio
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (to) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${to}`;
    } else {
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="header__content">
        {/* Logo */}
        <div className="header__logo-container">
          <div className="header__logo-img-cont">
            <RouterLink to="/" className="header__logo-link">
              <img src={profileLogo} alt="Jorge Casagrande Logo" className="header__logo-img" />
            </RouterLink>
          </div>
          <span className="header__logo-sub">Jorge Casagrande</span>
        </div>

        {/* Main Navigation */}
        <div className="header__main">
          <ul className={`header__links ${isMenuOpen ? 'header__sm-menu--active' : ''}`}>
            <li className="header__link-wrapper">
              {location.pathname === '/' ? (
                <ScrollLink
                  to="hero"
                  smooth={true}
                  duration={SCROLL_DURATION}
                  className="header__link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </ScrollLink>
              ) : (
                <RouterLink to="/" className="header__link" onClick={() => handleNavigation('hero')}>
                  Home
                </RouterLink>
              )}
            </li>
            <li className="header__link-wrapper">
              {location.pathname === '/' ? (
                <ScrollLink
                  to="about"
                  smooth={true}
                  duration={SCROLL_DURATION}
                  className="header__link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  About
                </ScrollLink>
              ) : (
                <RouterLink to="/" className="header__link" onClick={() => handleNavigation('about')}>
                  About
                </RouterLink>
              )}
            </li>
            <li className="header__link-wrapper">
              {location.pathname === '/' ? (
                <ScrollLink
                  to="projects"
                  smooth={true}
                  duration={SCROLL_DURATION}
                  className="header__link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Projects
                </ScrollLink>
              ) : (
                <RouterLink to="/" className="header__link" onClick={() => handleNavigation('projects')}>
                  Projects
                </RouterLink>
              )}
            </li>
            <li className="header__link-wrapper">
              {location.pathname === '/' ? (
                <ScrollLink
                  to="contact"
                  smooth={true}
                  duration={SCROLL_DURATION}
                  className="header__link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contact
                </ScrollLink>
              ) : (
                <RouterLink to="/" className="header__link" onClick={() => handleNavigation('contact')}>
                  Contact
                </RouterLink>
              )}
            </li>
          </ul>

          {/* Hamburger Menu */}
          <div className="header__main-ham-menu-cont" onClick={toggleMenu}>
            {!isMenuOpen ? (
              <img src={hamMenu} alt="Open menu" className="header__main-ham-menu" />
            ) : (
              <img src={hamMenuClose} alt="Close menu" className="header__main-ham-menu-close" />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;